// File: src/store/middleware/auth-middleware.ts
// Purpose: Redux middleware to sync authentication with GraphQL client
// VIBE - Auth Middleware

import { Middleware } from '@reduxjs/toolkit'
import { setAuthToken, clearAuthToken } from '@/lib/graphql/client'

export const authMiddleware: Middleware = (store) => (next) => (action) => {
  // Process the action first
  const result = next(action)

  // Check if this is an auth-related action
  if (action.type === 'auth/setAuthData' || action.type === 'auth/loginSuccess') {
    const state = store.getState()
    const token = state.auth?.accessToken

    if (token) {
      // Set token in GraphQL client
      setAuthToken(token)

      // Also ensure it's in localStorage for persistence
      if (typeof window !== 'undefined') {
        localStorage.setItem('token', token)
        localStorage.setItem('staffToken', token)

        // Store user-scoped token if userId available
        const userId = state.auth?.userId
        if (userId) {
          localStorage.setItem(`token:${userId}`, token)
        }
      }
    }
  }

  // Clear token on logout
  if (action.type === 'auth/logout' || action.type === 'auth/clearAuth') {
    clearAuthToken()

    if (typeof window !== 'undefined') {
      localStorage.removeItem('token')
      localStorage.removeItem('staffToken')
      localStorage.removeItem('staffUser')

      // Clear all user-scoped tokens
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i)
        if (key && key.startsWith('token:')) {
          localStorage.removeItem(key)
        }
      }
    }
  }

  return result
}

// Initialize auth on app load
export const initializeAuth = () => {
  if (typeof window === 'undefined') return

  try {
    // Check for existing auth data
    const authData = localStorage.getItem('instadev-auth')
    if (authData) {
      const parsed = JSON.parse(authData)
      if (parsed.accessToken) {
        setAuthToken(parsed.accessToken)
      }
    } else {
      // Fallback to legacy token storage
      const token = localStorage.getItem('token') || localStorage.getItem('staffToken')
      if (token) {
        setAuthToken(token)
      }
    }
  } catch (error) {
    console.error('Failed to initialize auth:', error)
  }
}